import React from "react";
import { connect } from "react-redux";
import { Field, FieldArray, reduxForm, getFormValues } from "redux-form";
import axios from "axios";
import _ from "lodash";

import Input from "components/Input";
import Select from "components/Select";
import AddBlock from "../../partials/AddBlock";
import BackgroundBlock from "../../partials/BackgroundBlock";
import ButtonsRow from "../../partials/ButtonsRow";
import CommentBlock from "../../partials/Comment";
import Validations from "helpers/validations";
import { limitDecimals } from "helpers/formatting";

import "./style.scss";

interface IProps {
  formValues: any;
  invalid: boolean;
  goNext: () => void;
  goBack: () => void;
}

interface IState {
  articleOptions: any[];
}

class StepFour extends React.Component<IProps, IState> {
  constructor(props) {
    super(props);

    this.state = {
      articleOptions: [],
    };
  }

  public componentDidMount() {
    axios
      .get(
        "Items?$filter=TypeId eq 'ExtraCosts' and Active eq true and PortalActive eq true"
      )
      .then(({ data }) => {
        const capiItemOptions = _.get(data, "value", []);
        const articleOptions = _(capiItemOptions)
          .map((option) => ({
            label: option.Description,
            value: option.Id,
          }))
          .sortBy("label")
          .value();

        this.setState({ articleOptions });
      });
  }

  private getOrderNumbers = () =>
    _(this.props.formValues.orderLines)
      .map("orderNummer")
      .uniqBy("label")
      .value();

  public render() {
    const { goNext, goBack, invalid } = this.props;

    return (
      <div id="step-four">
        <FieldArray
          name="extraCostLines"
          component={this.renderExtraCostLines}
          rerenderOnEveryChange
        />
        <ButtonsRow
          goNext={goNext}
          goBack={goBack}
          showBackBtn
          disabled={invalid}
        />
      </div>
    );
  }

  private renderExtraCostLines = ({ fields }) => (
    <div>
      {fields.map((item, index) => (
        <BackgroundBlock
          key={index}
          showCloseBtn
          removeBlock={() => fields.remove(index)}
        >
          <div className="step-four-row">
            <Field
              containerClassName="form-field"
              className="min-width-select-forms"
              name={`${item}.article`}
              label="ARTICLE"
              component={Select}
              options={this.state.articleOptions}
              validate={[Validations.required]}
            />
            <Field
              containerClassName="form-field"
              name={`${item}.description`}
              label="DESCRIPTION"
              component={Input}
              validate={[Validations.maxLength(50)]}
            />
            <Field
              containerClassName="form-field"
              name={`${item}.amount`}
              label="AMOUNT"
              parse={limitDecimals}
              component={Input}
              validate={[Validations.required, Validations.positive]}
              type="number"
            />
            <Field
              containerClassName="form-field"
              className="min-width-select-forms"
              name={`${item}.costTo`}
              label="DELIVERIES_FOR"
              component={Select}
              options={this.getOrderNumbers()}
              validate={[Validations.required]}
            />
          </div>
          <Field
            name={`${item}.comment`}
            component={CommentBlock}
            maxLength={80}
          />
        </BackgroundBlock>
      ))}
      <AddBlock
        addBlock={() => fields.push({ costTo: this.getOrderNumbers()[0] })}
        text="DELIVERIES_ADD_LINE"
      />
    </div>
  );
}

const StepFourWithReduxForm = reduxForm({
  form: "delivery",
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
})(StepFour);

export default connect((state) => ({
  formValues: getFormValues("delivery")(state),
}))(StepFourWithReduxForm);
